import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface ButtonProps {
  to?: string;
  href?: string;
  children: ReactNode;
  variant?: "primary" | "accent" | "outline" | "ghost";
  className?: string;
  icon?: string;
  onClick?: () => void;
  type?: "button" | "submit";
}

export default function Button({
  to,
  href,
  children,
  variant = "primary",
  className = "",
  icon,
  onClick,
  type = "button",
}: ButtonProps) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-md px-6 py-3 text-sm font-semibold transition cursor-pointer whitespace-nowrap";
  const variants: Record<string, string> = {
    primary: "bg-primary-500 text-background-50 hover:bg-primary-600",
    accent: "bg-accent-500 text-background-50 hover:bg-accent-600",
    outline: "border border-primary-300 text-primary-700 hover:bg-primary-50",
    ghost: "text-primary-700 hover:bg-primary-50",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  const content = (
    <>
      {icon && <i className={`${icon} text-base w-4 h-4 flex items-center justify-center`} />}
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={cls}>
        {content}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} className={cls}>
      {content}
    </button>
  );
}